import repository from "../Repository";

export default {
  list(screenId) {
    return repository.post(
      `disaster_delivery`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
